global.browserActionRun = function(action) {
    var actionParam = action.split('_');
    action = actionParam[0];
    
    switch(action) {
        case 'close':
          browserActionCloseWindow();
          break;
        case 'refresh':
          browserActionRefresh();
          break;
        case 'history':
          browserActionHistory(actionParam[1]);
          break;
        case 'print':
          browserActionPrint();
          break;
        case 'logout':
          browserActionLogout();
          break;
        case 'fullscreen':
          browserActionToggleFullScreen();
          break;
        case 'textsize':
          browserActionFontSize(actionParam[1]);
          break;
    }
}

global.browserActionCloseWindow = function() {
    setTimeout(function(){var ww = window.open(window.location, '_self'); ww.close(); }, 500);
}

global.browserActionRefresh = function() {
    document.location.reload(true);
}

global.browserActionHistory = function(position) {
    history.go(position);
}

global.browserActionPrint = function() {
    window.print();
}

global.browserActionLogout = function() {
    ajaxForm({
        url: 'api/users/logout/',
        method: 'POST',
        target: this,
        callback: function(data, form) {
            browserActionRefresh();
        },
        error: function(data, form) {
            browserActionRefresh();
        },
        success: function(data, form) {
            browserActionRefresh();
        }
    });
}

global.browserActionToggleFullScreen = function() {
  if((document.fullScreenElement && document.fullScreenElement !== null) ||    // alternative standard method
  (!document.mozFullScreen && !document.webkitIsFullScreen)) {               // current working methods
    if(document.documentElement.requestFullScreen) {
      document.documentElement.requestFullScreen();
    } else if(document.documentElement.mozRequestFullScreen) {
      document.documentElement.mozRequestFullScreen();
    } else if(document.documentElement.webkitRequestFullScreen) {
      document.documentElement.webkitRequestFullScreen(Element.ALLOW_KEYBOARD_INPUT);
    }
  } else {
    if(document.cancelFullScreen) {
      document.cancelFullScreen();
    } else if(document.mozCancelFullScreen) {
      document.mozCancelFullScreen();
    } else if(document.webkitCancelFullScreen) {
      document.webkitCancelFullScreen();
    }
  }
}

global.browserActionFontSize = function(size) {
    changeFontSize(size);
}

global.cmsAnchor = function(element) {
    var el = $(element);
    if (el.length) {
        $.scrollTo(el, 500 );
    }
    else {
        window.location.href = $('base').attr('href')+element;
    }
}
